import { ActionItem } from '../../../components/my-component/UI/grid/ambient-template-grid/interfaces/gridInterfaces';

export const getActionColumnWidth = (actionList: ActionItem[]) => {
  if (!actionList || actionList?.length === 0) return;

  switch (actionList?.length) {
    case 1:
      return 121;
    case 2:
      return 121;
    case 3:
      return 161;
    default:
      return 200;
  }
};

export const sortActionItemOrder = (actionList: ActionItem[]) => {
  if (!actionList || actionList?.length === 0) return [];

  return actionList?.sort((a, b) => {
    if (a?.order && b?.order) {
      return a.order - b.order;
    }
    return 0;
  });
};

export const splitActionList = (actionList, maximumVisibleActions) => {
  const visibleActions = [];
  const overflowActions = [];

  for (let i = 0; i < actionList.length; i++) {
    if (i < maximumVisibleActions) {
      visibleActions.push(actionList[i]);
    } else {
      overflowActions.push(actionList[i]);
    }
  }

  return { visibleActions, overflowActions };
};
